export const CARTOGRAPHER_ALLOWED_MIME_TYPES = [
  'model/gltf-binary',
  'model/gltf+json',
  'application/octet-stream',
];

export const CARTOGRAPHER_ACCEPT_EXTENSIONS = ['.glb', '.gltf', '.fbx'];
